"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = __importDefault(require("./styles"));
const ErrorMessage = ({ className, message, svg, title, }) => {
    const classes = styles_1.default({ svg });
    return (react_1.default.createElement("div", { className: className || classes.errorMessageContainer },
        react_1.default.createElement("div", { className: "svgContainer" }, svg),
        react_1.default.createElement("div", { className: "titleContainer" },
            react_1.default.createElement(core_1.Typography, { className: classes.title }, title)),
        message ? (react_1.default.createElement("div", { className: "messageContainer" },
            react_1.default.createElement(core_1.Typography, { className: classes.message }, message))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = ErrorMessage;
